module.exports = __webpack_public_path__ + "img/competencies_banner_mobile.ce9fd334.jpg";